module.exports = __webpack_public_path__ + "assets/img/DS-master (3).71cf92e5.jpg";